import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose, withHandlers, withStateHandlers } from 'recompose';
import { Button, ButtonToolbar, Clearfix, Modal } from 'react-bootstrap';


import TicketAttachmentUploadForm, { getTicketAttachmentUploadForm } from './TicketAttachmentUploadForm';
import { submitTicketAttachmentUpload } from './actions';


export const uploadAttachmentsModalPropTypes = {
  showUploadAttachmentsModal: PropTypes.bool.isRequired,
  openUploadAttachmentsModal: PropTypes.func.isRequired,
  closeUploadAttachmentsModal: PropTypes.func.isRequired,
};


export const withUploadAttachmentsModalState = withStateHandlers(
  (props) => { return { showUploadAttachmentsModal: false }; },
  {
    openUploadAttachmentsModal: (state, props) => {
      return () => { return { showUploadAttachmentsModal: true }; };
    },
    closeUploadAttachmentsModal: (state, props) => {
      return () => { return { showUploadAttachmentsModal: false }; };
    },
  },
);


const propTypes = exact({
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  ticketId: PropTypes.number.isRequired,

  ticketAttachmentUploadForm: PropTypes.object.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  submitTicketAttachmentUploadAction: PropTypes.func.isRequired,
  submitTicketAttachmentUploadForm: PropTypes.func.isRequired,
});


const TicketAttachmentUploadModal = (props) => {
  const { show, onHide, ticketId } = props;
  const { ticketAttachmentUploadForm } = props;
  const { submitTicketAttachmentUploadForm } = props;

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Upload Ticket Attachments</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TicketAttachmentUploadForm ticketId={ticketId} />
        <Clearfix>
          <ButtonToolbar className="pull-right">
            <Button
              bsStyle="warning"
              onClick={onHide}
            >
              Cancel
            </Button>
            <Button
              bsStyle="primary"
              onClick={submitTicketAttachmentUploadForm}
              disabled={ticketAttachmentUploadForm.invalid || ticketAttachmentUploadForm.submitting}
            >
              Upload
            </Button>
          </ButtonToolbar>
        </Clearfix>
      </Modal.Body>
    </Modal>
  );
};


TicketAttachmentUploadModal.propTypes = propTypes;


const mapStateToProps = (state) => {
  return {
    ticketAttachmentUploadForm: getTicketAttachmentUploadForm(state),
  };
};

const mapDispatchToProps = {
  submitTicketAttachmentUploadAction: submitTicketAttachmentUpload,
};


const withRedux = connect(mapStateToProps, mapDispatchToProps);


const withSubmitFormHandler = withHandlers({
  submitTicketAttachmentUploadForm: (props) => {
    return async () => {
      const { values } = props.ticketAttachmentUploadForm;
      const { ticketId, onHide } = props;
      await props.submitTicketAttachmentUploadAction(values, ticketId);
      onHide();
    };
  },
});


const enhance = compose(
  withRedux,
  withSubmitFormHandler,
);


export default enhance(TicketAttachmentUploadModal);
